import { Instance } from 'mobx-state-tree'

import { RootStoreBase } from './RootStore.base'

export interface RootStoreType extends Instance<typeof RootStore> {}

export const RootStore = RootStoreBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
